module.exports = __webpack_public_path__ + "img/mask.ec78a79b.jpeg";